import type { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Injectable } from '@angular/core';
import type { FormArray } from '@angular/forms';
import { FormControl } from '@angular/forms';

@Injectable()
export abstract class ReorderLocationsFacade {
  public execute(event: CdkDragDrop<any>) {
    if (!this.whetherChangedPosition(event)) {
      return;
    }

    this.locationsControl.markAsTouched();

    const locationIds: number[] = [...(this.locationsControl.value || [])];
    const movedLocationId = locationIds.splice(event.previousIndex, 1)[0];
    locationIds.splice(event.currentIndex, 0, movedLocationId);
    this.setLocationsControl(locationIds);
  }

  public abstract get locationsControl(): FormArray<FormControl>;

  private whetherChangedPosition(event: CdkDragDrop<any>): boolean {
    return event.currentIndex !== event.previousIndex;
  }

  private setLocationsControl(locationIds: number[]) {
    this.locationsControl.clear({ emitEvent: false });
    locationIds.forEach(id => {
      this.locationsControl.push(new FormControl(id), { emitEvent: false });
    });
    this.locationsControl.markAsDirty();
    this.locationsControl.updateValueAndValidity();
  }
}
